export default __webpack_public_path__ + "static/media/image-visit-showroom.691b156a.png";